// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__t88Go","showModal":"Modal_showModal__jJubt","outer":"Modal_outer__2D9m_","close":"Modal_close__3EvEs"};